import { CustomFieldDataType, CustomFieldOption } from '@portal/types/entities/custom-field';
import { amountFormats } from '@sinecycle/growcomponents';
export const validNumberBasedFields = ['NUMBER', 'DECIMAL'] as const;
export function getCustomFieldOptions(
  options: Array<CustomFieldOption>,
  data_type: CustomFieldDataType,
  locale?: string,
) {
  return options.map((option) => {
    return {
      key: option,
      value: option,
      label:
        data_type === 'NUMBER'
          ? amountFormats.number(option as unknown as number, { locale })
          : data_type === 'DECIMAL'
          ? amountFormats.number(option as unknown as number, { locale, mode: 'DECIMAL' })
          : option,
    };
  });
}
